import './vendor/velocity';

import './cookie-consent.ts';

import Header from './header';
var header = new Header('.js-header');

import Slideshow from './slideshow';
var slideshow = new Slideshow('.js-slideshow', 5500);

import fitVids from './vendor/fitvids';
document.addEventListener('DOMContentLoaded', () => {
	fitVids('.entry__content');
});

import Form from './form';
var form;
if (jQuery('.js-form').length) {
	form = new Form({
		element: jQuery('.js-form'),
	});
}
